import { L } from 'harmony-language';
import { OrganizationLocation, TripEvent } from '../../../../types';
import { toSiteDisplayName } from '../../../../utils/data-mapping';
import { pointInZone } from '../../../../utils/map-utils';

export const findKnownLocationOrLatLng = (tripEvent: TripEvent, locations: OrganizationLocation[]) => {
    const tsLatitude = tripEvent.latitude;
    const tsLongitue = tripEvent.longitude;

    if (tsLatitude && tsLongitue) {
        const foundLocation = locations.find(x => x.customGeofence ? pointInZone({ latitude: tsLatitude, longitude: tsLongitue }, x.customGeofence) : false);

        if (foundLocation) {
            return ' [' + L.knownLocation() + ': ' + toSiteDisplayName(foundLocation.name, foundLocation.description) + ']';
        } else {
            return ' - ' + tripEvent.latitude + ', ' + tripEvent.longitude;
        }

    } else {
        return ' - ' + L.locationUnknown();
    }
}
